import intellij from "../imgs/intellij-idea-svgrepo-com.svg";
import eclipse from "../imgs/eclipse-icon-svgrepo-com.svg";
import vscode from "../imgs/vs-code-svgrepo-com.svg";
import git from "../imgs/github-142-svgrepo-com.svg";
import slack from "../imgs/slack-svgrepo-com.svg";
import discord from "../imgs/discord-svgrepo-com.svg";
import { useState } from "react";
import './collaboration.css';


function Collaboration () {
    const [correct, setCorrect] = useState([false]);
    const [isWrong, setIsWrong] = useState([false]); // 틀렸을 때 메시지

    const checkAnswer = (answer, num) => {
        if (answer === "eclipse" && num === 0) {
            // 배열의 특정 인덱스를 바로 변경
            setCorrect(prev => prev.map((val, index) => index === num ? true : val));
        } else {
            setIsWrong(prev => prev.map((val, index) => index === num ? true : val)); // 틀린 답 처리
            setTimeout(() => {
                setIsWrong(prev => prev.map((val, index) => index === num ? false : val)); // 1초 후 흔들림 상태 초기화
            }, 1500); // 애니메이션 시간이 끝난 후 초기화
        }
    };

    return(
        <div className="collaborations">
            <div className="collaborations-header">Tools & Collaboration</div>

            <div className={`collaboration-quiz ${isWrong[0] ? 'wrong-answer' : correct[0] ? 'collaboration-correct-answer' : ''}`} >
                <div className="collaboration-quiz-question">
                    Question. "  "는 Java를 기반으로 한 통합 개발 환경으로, Java는 썬 마이크로시스템즈에서 개발한 프로그래밍 언어이므로 태양(sun)과 관련 있는 개기일식을 의미한다.
                </div>
                <div className="collaboration-quiz-answer">
                    <div className="first" onClick={() => checkAnswer("intellij", 0)}>
                        <img src={intellij} alt="Intellij" />
                    </div>
                    <div className="second" onClick={() => checkAnswer("vscode", 0)}>
                        <img src={vscode} alt="Vscode" />
                    </div>
                    <div className="third" onClick={() => checkAnswer("eclipse", 0)}>
                        <img src={eclipse} alt="Eclipse" />
                    </div>
                </div>
                {isWrong[0] && <div className="wrong">다시 생각해보세요</div>}
                {correct[0] && <div className="correct-message">정답!</div>}
            </div>

            <div
                className={`collaborations-stack ${correct[0] ? 'show-collaborations' : ''}`}
                style={{ display: correct[0] ? 'flex' : 'none' }}
            >
                <div className="stack-imgs">
                    <img src={vscode} alt="Vscode" />
                    <div className="stack-txt">Vscode</div>
                </div>
                <div className="stack-imgs">
                    <img src={eclipse} alt="Eclipse" />
                    <div className="stack-txt">Eclipse</div>
                </div>
                <div className="stack-imgs">
                    <img src={git} alt="Git" />
                    <div className="stack-txt">Git</div>
                </div>
                <div className="stack-imgs">
                    <img src={slack} alt="Slack" />
                    <div className="stack-txt">Slack</div>
                </div>
                <div className="stack-imgs">
                    <img src={discord} alt="Discord" />
                    <div className="stack-txt">Discord</div>
                </div>
            </div>

        </div>
    );
}

export default Collaboration;